import { temuPlatformAPI } from '@/temu-platform/api/temuPlatformApi';
import { adminAPI } from '@/utils/adminApi';

/**
 * 管理端「官方模板」按父级懒加载 Temu 类目。
 * 官方目录缓存只有一级，后台没有 shopId，需借同类型已授权店铺拉子类目。
 * @param {string} shopType
 * @returns {(parentNode: object) => Promise<object[]>}
 */
export function createTemuOfficialCategoryChildrenLoader(shopType) {
  return async (parentNode) => {
    const parentId = parentNode?.category_id ?? parentNode?.catId ?? parentNode?.categoryId;
    if (parentId == null || parentId === '') {
      return [];
    }
    const res = await adminAPI.getOfficialTemuCatalogCategoryChildren({
      shopType,
      parentCatId: parentId,
    });
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.categoryDTOList)) return res.categoryDTOList;
    if (Array.isArray(res?.categories)) return res.categories;
    if (Array.isArray(res?.result?.categoryDTOList)) return res.result.categoryDTOList;
    return [];
  };
}

/**
 * 按父级懒加载 Temu 类目（平台全量树过大，店铺同步只缓存一级）。
 * @param {string|number} shopId
 * @returns {(parentNode: object) => Promise<object[]>}
 */
export function createTemuCategoryChildrenLoader(shopId) {
  return async (parentNode) => {
    const parentId = parentNode?.category_id ?? parentNode?.catId ?? parentNode?.categoryId;
    if (parentId == null || parentId === '') {
      return [];
    }
    const res = await temuPlatformAPI.getPublishCategories(shopId, parentId);
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.categoryDTOList)) return res.categoryDTOList;
    if (Array.isArray(res?.categories)) return res.categories;
    if (Array.isArray(res?.result?.categoryDTOList)) return res.result.categoryDTOList;
    return [];
  };
}
